import script from "./AdminMailings.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminMailings.vue?vue&type=script&setup=true&lang=js"

import "./AdminMailings.vue?vue&type=style&index=0&id=0c9a2a1b&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0c9a2a1b"]])

export default __exports__